// ============================================================================
// UNIVERSAL ACTION HANDLERS - FILE MANAGEMENT ACTIONS
// ============================================================================

import type { UniversalActionHandlers } from "./types";

/**
 * File Management Actions
 */
export const fileManagementActions: UniversalActionHandlers = {
  // Upload file action - opens upload modal
  uploadFile: async (item, context) => {
    context.onOpenModal("upload-file", { item });
  },
};
